import React from 'react';
import Helmet from 'react-helmet';

import Heading from 'pubweb-react-components/dist/components/Typography/Heading';
import BodyCopy from 'pubweb-react-components/dist/components/Typography/BodyCopy';
import Button from 'pubweb-react-components/dist/components/Buttons/Button';

import colors from 'pubweb-react-components/dist/styles/colors';

import UrlUtility from '../../utils/UrlUtility';
import GeoLocationService from '../../services/GeoLocationService';

import { send } from '../../utils/Analytics';
import { onHelmetChangeClientState } from '../../utils/Analytics';

import ThankYouMessageContainer from './ThankYouMessageStyles';

const ThankYouMessage = ({ gaEventLabel, tyType, blurbType }) => {
    let viewHomesUrl = "https://www.claytonhomes.com/find-a-home";
    const zipCode = UrlUtility.getValue("zip");
    let city, state;

    if (zipCode) {
        GeoLocationService.geocodeZip(zipCode).then((response) => {
            city = response.city;
            state = response.state;
            viewHomesUrl = `${viewHomesUrl}/${city}--${state}--${zipCode}`;            
        });
    }

    var viewHomesClick = () => {
        send('HIM2018', 'Button', gaEventLabel);

        if (typeof sessionStorage !== 'undefined') {
            const redirectUrl = sessionStorage.getItem('redirectUrl');
            if (redirectUrl) {
                viewHomesUrl = viewHomesUrl + redirectUrl;
            }
        }

        window.location.href = viewHomesUrl;
    }

    return (
        <ThankYouMessageContainer>
            {tyType === "Thank you" ? 
                <Helmet 
                    onChangeClientState={onHelmetChangeClientState}
                    title="Thank you" 
                    />
                :
                <Helmet 
                    onChangeClientState={onHelmetChangeClientState}
                    title="Thanks" 
                    />
            }
            <div className="background-filter">
                <div className="thank-you-message">
                    <div className="thank-you-header">
                        <Heading
                            headingSize="xxlarge"
                            headingTag="h1">
                            Thank You!
                        </Heading>

                        {blurbType === "quiz" ? 
                            <BodyCopy paragraphType="larger-intro">
                                Thank you! Just one more step to go - click the button below to view homes that match your style personality.
                            </BodyCopy> : 

                            <BodyCopy paragraphType="larger-intro">
                                Click <a href="https://www.claytonhomes.com/home-buyers-guide" target="_blank">here</a> to access your Home Buyer's Guide.
                                We will also email you a link so you can easily find it once you navigate away from this site.
                            </BodyCopy>
                        
                        }

                    </div>
                    <div className="thank-you-rule"></div>
                    <div className="thank-you-footer">
                        <BodyCopy paragraphType="larger-intro">Ready to take the next step?</BodyCopy>
                        <Button
                            size="large"
                            onButtonClick={viewHomesClick}
                            buttonClass="primary-button"
                            backgroundColor={colors.secondaryKiddiePool}
                            backgroundColorHover="#008b88"
                            buttonText="View Homes"
                        />
                    </div>
                </div>
            </div>
        </ThankYouMessageContainer>
    )
}

export default ThankYouMessage;


// WEBPACK FOOTER //
// ./src/components/ThankYou/ThankYouMessage.js